module.exports = __webpack_public_path__ + "static/media/aboutMeImage.178c6542.png";